import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Icon from '../ui/Icon';
import { STUDENT_NAV, isNavActive } from './studentNav';

/** Phone navigation: four destinations, thumb-height, safe-area aware. Hidden from 900px (the app bar shows tabs). */
export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav className="z-bottomnav" aria-label="Primary">
      {STUDENT_NAV.map(item => {
        const active = isNavActive(item, pathname);
        return (
          <NavLink key={item.path} to={item.path} className={`z-bottomnav-item${active ? ' active' : ''}`} aria-current={active ? 'page' : undefined}>
            <span className="z-bottomnav-icon"><Icon name={item.icon} size={22} strokeWidth={active ? 2.4 : 2} /></span>
            <span className="z-bottomnav-label">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
